import {
  ReportSection,
  ReportSectionConfigurationBase,
  ReportSectionConfigurationControlType,
  ReportSectionDataSection,
  ReportType,
  ReportViewModelSection
} from '@capital-access/reporting/common';
import { TopHoldersModel } from './top-holders.model';

export class TopHoldersConfiguration extends ReportSectionConfigurationBase {
  typeName = 'TopHoldersConfiguration';
  nodataLocalizationKeyName = 'bnyTopHolders';
  readonly reportSection = ReportSection.TopHolders;
  readonly applicableReportTypes = [ReportType.BnyManagementReport];
  readonly reportViewModelSections = [ReportViewModelSection.BnyManagementReport_TopHolders];
  minSize = 2;
  maxSize = 4;
  defaultSize = 2;

  readonly availableDataSections: ReportSectionDataSection[] = [
    {
      name: 'name',
      displayName: 'Name',
      isSelected: true,
      canConfigure: false,
      unit: 1,
      property: 'security',
      isStatic: true,
      type: ReportSectionConfigurationControlType.Text
    },
    {
      name: 'location',
      displayName: 'Location',
      isSelected: true,
      canConfigure: true,
      unit: 2,
      property: 'location',
      type: ReportSectionConfigurationControlType.Text
    },
    {
      name: 'drsHeld',
      displayName: '# DRs Held',
      isSelected: true,
      canConfigure: true,
      unit: 2,
      property: 'drsHeld',
      type: ReportSectionConfigurationControlType.Number
    },
    {
      name: 'drAum',
      displayName: 'DR Equity Assets USD, mm',
      isSelected: true,
      canConfigure: true,
      unit: 2,
      property: 'drAum',
      type: ReportSectionConfigurationControlType.Decimal
    },
    {
      name: 'fileDate',
      displayName: 'File Date',
      isSelected: true,
      canConfigure: true,
      unit: 2,
      property: 'fileDate',
      type: ReportSectionConfigurationControlType.Date
    }
  ];

  get name(): string {
    if (this.appliedReportType === ReportType.BnyManagementReport) {
      return 'topHoldersTitle';
    } else {
      throw new Error('Report Type not supported');
    }
  }

  get displayName(): string {
    if (this.appliedReportType === ReportType.BnyManagementReport) {
      return 'Top Institutional Holders';
    } else {
      throw new Error('Report Type not supported');
    }
  }
}

export interface TopHoldersData {
  [ReportViewModelSection.BnyManagementReport_TopHolders]: {
    topHolders: TopHoldersModel[];
  };
}
